import { S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import { specialCh } from "../variables";

const s3Client = new S3Client({
    region: "eu-west-3",
    credentials: {
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    },
});

// Function to send file to S3
export const sendToS3 = async (file, folder, onProgress) => {
    // if (!file || !file.name) {
    //     console.error("Invalid file");
    //     return null;
    // }

    console.log("Uploading file:", file.name);
    
    // Replace special chars with underscores
    const specialChars = specialCh;
    const sanitizedFileName = file.name.replace(new RegExp(`[${specialChars}]`, "g"), "_");

    // Get current date and time as YYYYMMDD_HHmmss
    const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "").slice(0, 15);

    // Extract filename and extension
    const lastDotIndex = sanitizedFileName.lastIndexOf(".");
    const nameWithoutExt = lastDotIndex !== -1 ? sanitizedFileName.slice(0, lastDotIndex) : sanitizedFileName;
    const extension = lastDotIndex !== -1 ? sanitizedFileName.slice(lastDotIndex) : "";

    // Construct the new file name (appending the timestamp before the extension)
    const uniqueFileName = `${nameWithoutExt}_${timestamp}${extension}`;
    try {
        const upload = new Upload({
            client: s3Client,
            params: {
                Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
                Key: `${folder}/${uniqueFileName}`,
                // Key: `test/${uniqueFileName}`,
                Body: file,
                ContentType: file.type, // Automatically determine the file type


            },
        });

        upload.on("httpUploadProgress", (progress) => {
            if (onProgress) {
                const percentCompleted = Math.round((progress.loaded * 100) / progress.total);
                onProgress(percentCompleted);
            }
        });


        const result = await upload.done();

        console.log("File uploaded successfully:", result);

        console.log("File uploaded successfully:", result.Location);

        const url = new URL(result.Location);
        const relativePath = url.pathname.startsWith("/uploads") ? url.pathname.substring(1) : url.pathname;

        return relativePath; // The URL to the uploaded file
    } catch (error) {
        console.error("Error uploading file:", error);
        return null;
    }
};